import React, {useEffect, useRef, useState} from "react";
import Slider from "react-slick";
import ProviderCard from './ProviderCard';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./ProviderSlider.css";
import {Row} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faExternalLinkAlt} from "@fortawesome/free-solid-svg-icons";
import {ROLE_SYSTEM} from "./Templates";

const ProviderSlider = ({buttonClick, data: {urlData, buttons, goToSlide, onSlide, fromMap=false,providers=[]}, role, last, buttonClicked, scrollToBottom}) => {
    const [physiciansData, setPhysiciansData] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    let slider = useRef();
    const settings = {
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        centerMode: true,
        afterChange: current => onSlide ? onSlide(current) : null
    };

    useEffect(() => {
        if(!fromMap) {
            getData();
        }
    }, []);
    useEffect(()=>{
        if (providers.length) {
            setPhysiciansData(providers)
        }
    },[providers])
    useEffect(() => {
        if (goToSlide !== false)
            slider.current.slickGoTo(goToSlide);
    }, [goToSlide]);

    const getData = () => {

        setIsLoading(true);
        fetch(urlData,
            {
                headers : {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Access-Control-Request-Method': 'GET',
                    'Access-Control-Request-Headers': 'Content-Type, Authorization'
                }
            }
        )
            .then(function (response) {
                return response.json();
            })
            .then(function (result) {
                let data = result !== undefined ? result : {};
                setPhysiciansData(data);
                setIsLoading(false);
                if (!fromMap) {
                    scrollToBottom()
                }
            });
    };
    const showMap = () => {
        window.parent.postMessage({'name': 'showMap', value: physiciansData}, '*')
    }
    const showList = () => {
        window.parent.postMessage({'name': 'showList', value: physiciansData}, '*')
    }

    return <>
        <div className="provider-slider">
            {
                isLoading && !fromMap ?
                    <div className="message typing">
                        <span className="dot"></span>
                        <span className="dot"></span>
                        <span className="dot"></span>
                    </div> : ''
            }
            <Slider ref={slider} {...settings}>
                {
                    physiciansData.length > 0 ?
                        physiciansData.map((item) => {
                            return <ProviderCard data={item} key={item.id}/>;
                        }) : ''
                }
            </Slider>
        </div>
        {
            buttons !== undefined && buttons.length > 0
            && !isLoading
            && role === ROLE_SYSTEM
            && last
            && !buttonClicked
                ?
                <Row className={"message-buttons provider-buttons visible"}>
                    <React.Fragment key={'msg_btn_show_map'}>
                        <a className={"template__href show_map"}
                           onClick={() => showMap()}>
                            <span>Show on map</span>
                        </a>
                    </React.Fragment>
                    <React.Fragment key={'msg_btn_show_list'}>
                        <a className={"template__href show_list"}
                           onClick={() => showList()}>
                            <span>List view</span>
                        </a>
                    </React.Fragment>
                    <React.Fragment key={'msg_btn_different'}>
                        <a className={"template__href different_provider"}
                           onClick={() => buttonClick('Find a Provider\n', '')}>
                            <span>Find a different</span> <span>provider</span>
                        </a>
                    </React.Fragment>
                    {
                        buttons.map((button, key) =>
                            <React.Fragment key={'msg_btn_' + key}>
                                {
                                    (buttons.length > 1 && button.title === "Start Over") ? <br/> : ""
                                }
                                <a className={"template__href " + button.class}
                                   onClick={() => buttonClick(button.title, button.url)}><span>
                                    {
                                        button.title
                                    }
                                    {
                                        button.url && <FontAwesomeIcon icon={faExternalLinkAlt}/>
                                    }</span>
                                </a>
                            </React.Fragment>
                        )
                    }
                </Row> : ''
        }
    </>;
};

export default ProviderSlider;
